import { render } from "./CollectionItems.vue.js?vue&type=template&id=29de2b56!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionItems.vue?vue&type=template&id=29de2b56"
import script from "./CollectionItems.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionItems.vue?vue&type=script&lang=js"
export * from "./CollectionItems.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/CollectionItems.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29de2b56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29de2b56', __exports__)) {
    api.reload('29de2b56', __exports__)
  }
  
  module.hot.accept("./CollectionItems.vue.js?vue&type=template&id=29de2b56!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CollectionItems.vue?vue&type=template&id=29de2b56", () => {
    api.rerender('29de2b56', render)
  })

}


export default __exports__